import { createSelector } from 'reselect';
import {
  PAGE_TYPES,
  COLLECTIONS,
  BRAND_NAMES,
  BRANDS,
  APPROVED_THEMES,
} from '@nike/ciclp-config';
import { dataSelector } from './dataSelector';
import { isPreviewSelector, slugSelector } from '../router/routerSelector';

export const pageDataPropertiesSelector = createSelector(
  dataSelector,
  appData => appData?.pageData,
);

export const pageTypeSelector = createSelector(
  pageDataPropertiesSelector,
  pageData => pageData?.pageType ?? PAGE_TYPES.PAGE,
);

export const pageCollectionIdSelector = createSelector(
  pageDataPropertiesSelector,
  pageData => pageData?.collection,
);
/**
 * Information on whether we are currently on the nike journal or not
 * @returns {Boolean}
 */
export const isNikeJournalSelector = createSelector(
  pageDataPropertiesSelector,
  thread =>
    thread?.tagging?.taxonomyAttributes?.includes?.(
      COLLECTIONS.nikeJournal.taxonomyTag,
    ),
);
/** 
* Find the string pageColorTheme in the metadata decorations
* and searches only APPROVED_COLOR_THEMES map for a match.

 @returns {String?}
*/
export const findTheme = key => {
  const match = APPROVED_THEMES.find(
    theme => theme.toLowerCase() === key?.toLowerCase(),
  );
  return match ?? null;
};
/**
 * Information on whether there is a color theme in the metadata decorations
 * @returns {String?}
 */
export const colorThemeSelector = createSelector(
  pageDataPropertiesSelector,
  pageData => findTheme(pageData?.pageColorTheme),
);

const findBrand = predicate =>
  Object.values(BRAND_NAMES).find(predicate) ?? BRAND_NAMES.NIKE;

export const brandNameSelector = createSelector(
  isNikeJournalSelector,
  slugSelector,
  isPreviewSelector,
  pageCollectionIdSelector,
  (isNikeJournal, slug, isPreview, pageCollectionId) => {
    if (isNikeJournal) return BRAND_NAMES.NIKE_JOURNAL;
    if (!isPreview) {
      return findBrand(brandName =>
        new RegExp(`^/?${brandName}($|/)`).test(slug),
      );
    }

    return findBrand(
      brandName => pageCollectionId === BRANDS[brandName]?.collectionId,
    );
  },
);
